import React, { createContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SelectType } from '../components/DropdownSelect';
import LoginController from '../controller/LoginController';
import { StoreType } from '../controller/StoreController';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import { APP_TYPE } from '../utils/DataType';

export const AuthContext = createContext<any>(null);

type Props = {
  children: React.ReactNode;
};

export const AuthProvider = React.forwardRef((props: Props, oRef: any) => {
  const { children } = props;

  const [token, setToken] = React.useState('');
  const [refreshToken, setRefreshToken] = React.useState('');
  const [userInfo, setUserInfo] = React.useState<any>();
  const [currentStore, setCurrentStore] = useState<SelectType>();
  const [isLoggedIn, setIsLoggedIn] = React.useState<any>('');
  const [url, setUrl] = useState<string | null>(null);

  const handleLogin = async (
    sId: string,
    sPassword: string,
    bSaveId: boolean,
    bSavePw: boolean,
  ) => {
    let localUuid = await AsyncLocalStorage.getItem('uuid');

    if (!localUuid) {
      localUuid = JSON.stringify(uuidv4());
      AsyncLocalStorage.setItem('uuid', localUuid);
    }

    let oRes = await LoginController.signIn({
      id: sId.toString(),
      password: sPassword.toString(),
      device_uuid: localUuid,
      app_type: APP_TYPE.KNOCKWEB,
      version: null,
    });
    console.log('signIn', oRes.data);
    if (oRes.data && !oRes.data.ok) {
      return oRes.data;
    }

    if (oRes.data && oRes.data.ok) {
      let oUserData = oRes.data.data;
      setToken(oUserData.token);
      setRefreshToken(oUserData.refresh_token);
      setUserInfo(oUserData);
      const currentStore: StoreType = oUserData.store_list.find(
        (item: StoreType) => item.store_type === 1 || item.store_type === 4,
      );
      console.log('loginUserData', oUserData);

      if (currentStore) {
        setCurrentStore({
          key: 0,
          value: currentStore.store_id,
          name: currentStore.store_name,
          label: currentStore.store_name,
        });
        await AsyncLocalStorage.setItem(
          'ceo-currentStore',
          JSON.stringify({
            key: 0,
            value: currentStore.store_id,
            name: currentStore.store_name,
            label: currentStore.store_name,
          }),
        );
      }

      await AsyncLocalStorage.setItem('ceo-userToken', oUserData.token);
      await AsyncLocalStorage.setItem('ceo-userRefreshToken', oUserData.refresh_token);
      await AsyncLocalStorage.setItem('ceo-userData', JSON.stringify(oUserData));

      if (bSaveId === true) {
        await AsyncLocalStorage.setItem('ceo-savedId', sId.toString());
        await AsyncLocalStorage.setItem('ceo-savedIdCheck', bSaveId.toString());
      }
      if (bSavePw === true) {
        await AsyncLocalStorage.setItem('ceo-savedPassword', sPassword.toString());
        await AsyncLocalStorage.setItem('ceo-savedPasswordCheck', bSavePw.toString());
      }
    }
  };

  const handleLogout = async () => {
    const firebase_token = await AsyncLocalStorage.getItem('ceo-firebaseToken');
    if (firebase_token) {
      await LoginController.logout({
        firebase_token,
      });
      AsyncLocalStorage.removeItem('ceo-firebaseToken');
    }

    console.log('logout');
    setUserInfo(null);
    // AsyncLocalStorage.setItem('ceo-userData', '');
    // AsyncLocalStorage.setItem('ceo-userToken', '');
    // AsyncLocalStorage.setItem('ceo-userRefreshToken', '');
    // AsyncLocalStorage.setItem('ceo-currentStore', '');

    AsyncLocalStorage.removeItem('ceo-userToken');
    AsyncLocalStorage.removeItem('ceo-userRefreshToken');
    AsyncLocalStorage.removeItem('ceo-userData');
    AsyncLocalStorage.removeItem('ceo-currentStore');
    window.location.replace(`${process.env.REACT_APP_BASE_URL}`);
  };

  const onChangeCurrentStore = async () => {
    let oCurrentStore: any = await AsyncLocalStorage.getItem('ceo-currentStore');
    setCurrentStore(oCurrentStore || AsyncLocalStorage.getItem('currentStore'));
  };

  const value = {
    token,
    refreshToken,
    userInfo,
    currentStore,
    url,
    handleLogin: handleLogin,
    handleLogout: handleLogout,
    setUserInfo: setUserInfo,
    onChangeCurrentStore: onChangeCurrentStore,
  };

  const init = async () => {
    let sToken: string = await AsyncLocalStorage.getItem('ceo-userToken');
    let sRefreshToken: string = await AsyncLocalStorage.getItem('ceo-userRefreshToken');
    let oUserData: any = await AsyncLocalStorage.getItem('ceo-userData');
    let oCurrentStore: any = await AsyncLocalStorage.getItem('ceo-currentStore');

    // console.log(sToken, sRefreshToken, oUserData, oCurrentStore);

    setToken(sToken);
    setRefreshToken(sRefreshToken);
    setUserInfo(oUserData);
    setCurrentStore(oCurrentStore || AsyncLocalStorage.getItem('currentStore'));

    if (sToken && sRefreshToken && oUserData) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  };

  React.useImperativeHandle(oRef, () => ({
    _refLogout() {
      console.log('logout!!!!!!');
      handleLogout();
    },
  }));

  React.useEffect(() => {
    init();
  }, []);

  const receiveData = async (event: any) => {
    const receivedData = event.data;
    if (
      receivedData &&
      receivedData.type &&
      typeof receivedData.type === 'string' &&
      !receivedData.type.includes('webpack')
    ) {
      console.log('receivedData', receivedData);

      setUrl(receivedData.type);

        await AsyncLocalStorage.removeItem('ceo-userToken');
        await AsyncLocalStorage.removeItem('ceo-userRefreshToken');
        await AsyncLocalStorage.removeItem('ceo-userData');
        await AsyncLocalStorage.removeItem('ceo-currentStore');

        await AsyncLocalStorage.setItem('url', receivedData.type);
        await AsyncLocalStorage.setItem('ceo-userToken', receivedData.data.token);
        await AsyncLocalStorage.setItem('ceo-userRefreshToken', receivedData.data.refresh_token);
        await AsyncLocalStorage.setItem('ceo-userData', JSON.stringify(receivedData.data));

        setToken(receivedData.data.token);
        setRefreshToken(receivedData.data.refresh_token);
        setUserInfo(receivedData.data);
        setIsLoggedIn(true);

      const currentStore: StoreType = receivedData.data.store_list.find(
        (item: StoreType) => item.store_type === 1 || item.store_type === 4,
      );
      if (currentStore) {
        console.log('currentStore', currentStore);
        setCurrentStore({
          key: 0,
          value: currentStore.store_id,
          name: currentStore.store_name,
          label: currentStore.store_name,
        });
        await AsyncLocalStorage.setItem(
          'ceo-currentStore',
          JSON.stringify({
            key: 0,
            value: currentStore.store_id,
            name: currentStore.store_name,
            label: currentStore.store_name,
          }),
        );
      }
      console.log('post!!', receivedData);
    }
  };

  // const handlePosLogout = async () => {
  //   const url = await AsyncLocalStorage.getItem('url');
  //   if (url && url !== 'admin') {
  //     setTimeout(() => {
  //       handleLogout();

  //       AsyncLocalStorage.removeItem('url');
  //     }, 100);
  //   }
  // };

  const unmountCheck = async () => {
    const url = await AsyncLocalStorage.getItem('url');

    console.log('url', url, typeof url, url.length);

    if (url && url !== 'admin') {
      AsyncLocalStorage.removeItem('url');
      AsyncLocalStorage.removeItem('ceo-userRefreshToken');
      AsyncLocalStorage.removeItem('ceo-userData');
      AsyncLocalStorage.removeItem('ceo-currentStore');

      console.log('orderlink logout');
    }
  };

  const sendCheckAuthMsg = async () => {
    if (window.opener) {
      await window.opener.postMessage({ type: 'check_auth', msg: 'page got auth info' }, '*');
    }
  }

  React.useEffect(() => {
    window.addEventListener('message', receiveData);
    // window.addEventListener('beforeunload', handlePosLogout);
    sendCheckAuthMsg();

    return () => {
      window.removeEventListener('message', receiveData);
      // window.removeEventListener('beforeunload', handlePosLogout);

      unmountCheck();
    };
  }, []);

  if (isLoggedIn === '') {
    return <></>;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
});
